import { useState, useEffect } from 'react';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useAuthContext } from '../context/AuthContext';

/**
 * Real-time listener for incoming friend requests
 * Returns pending requests sent TO the current user
 */
export function useFriendRequests() {
  const { user } = useAuthContext();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setRequests([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, 'friendRequests'),
      where('to', '==', user.uid),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const results = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setRequests(results);
        setLoading(false);
      },
      (err) => {
        console.error('Error listening to friend requests:', err);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, [user]);

  return { requests, loading };
}
